import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "user.AddUser",
    path: `${APP_PREFIX_PATH}/User/createUser`,
    component: React.lazy(() => import("views/app-views/createUser/userAdd")),
  },
  {
    key: "user.UserList",
    path: `${APP_PREFIX_PATH}/User/userList`,
    component: React.lazy(() => import("views/app-views/createUser/userList")),
  },
  {
    key: "services.servicesAdd",
    path: `${APP_PREFIX_PATH}/services/servicesAdd`,
    component: React.lazy(() =>
      import("views/app-views/services/CreateService")
    ),
  },
  {
    key: "services.servicesList",
    path: `${APP_PREFIX_PATH}/services/servicesList`,
    component: React.lazy(() =>
      import("views/app-views/services/serviceList")
    ),
  },
  {
    key: "department.departmentCreate",
    path: `${APP_PREFIX_PATH}/department/departmentCreate`,
    component: React.lazy(() =>
      import("views/app-views/Department/CreateDepartment")
    ),
  },
  {
    key: "department.departmentList",
    path: `${APP_PREFIX_PATH}/department/departmentList`,
    component: React.lazy(() =>
      import("views/app-views/Department/DepatmentList")
    ),
  },
  {
    key: "terms.termsAdd",
    path: `${APP_PREFIX_PATH}/terms/termsAdd`,
    component: React.lazy(() =>
      import("views/app-views/termsAndConditions/addTermsAndConditions")
    ),
  },
  {
    key: "terms.termsList",
    path: `${APP_PREFIX_PATH}/terms/termsList`,
    component: React.lazy(() =>
      import("views/app-views/termsAndConditions/termsAndConditionsList")
    ),
  },
  {
    key: "bank.bankAdd",
    path: `${APP_PREFIX_PATH}/bank/addBank`,
    component: React.lazy(() => import("views/app-views/bankDetails/addBank")),
  },
  {
    key: "bank.bankList",
    path: `${APP_PREFIX_PATH}/bank/bankList`,
    component: React.lazy(() => import("views/app-views/bankDetails/bankList")),
  },
  {
    key: "leads.leadsList",
    path: `${APP_PREFIX_PATH}/leads/leadsList`,
    component: React.lazy(() => import("views/app-views/leads/leadsList")),
  },
  {
    key: "leads.leadsAdd",
    path: `${APP_PREFIX_PATH}/leads/leadsAdd`,
    component: React.lazy(() => import("views/app-views/leads/createLeads")),
  },
  {
    key: "requirements.listRequirements",
    path: `${APP_PREFIX_PATH}/requirements/requirementsList`,
    component: React.lazy(() =>
      import("views/app-views/Requirements/RequirementsHome")
    ),
  },
  {
    key: "requirements.addRequirements",
    path: `${APP_PREFIX_PATH}/requirements/requirementsAdd`,
    component: React.lazy(() =>import("views/app-views/Requirements/createEdit")),
  },
  {
    key: "requirements.addAnswer",
    path: `${APP_PREFIX_PATH}/requirements/addAnswer`,
    component: React.lazy(() =>import("views/app-views/Requirements/CreateEditReqAns")),
  },
  {
    key: "requirements.addList",
    path: `${APP_PREFIX_PATH}/requirements/answerList`,
    component: React.lazy(() =>import("views/app-views/Requirements/RequirementsAnswerList")),
  },
  {
    key: "requirements.addType",
    path: `${APP_PREFIX_PATH}/requirements/tyepeAdd`,
    component: React.lazy(() =>import("views/app-views/Requirements/RequirementsTypeAdd")),
  },
  {
    key: "requirements.typeList",
    path: `${APP_PREFIX_PATH}/requirements/tyepeList`,
    component: React.lazy(() =>import("views/app-views/Requirements/RequirementsTypeList")),
  },
  {
    key: "client.clientList",
    path: `${APP_PREFIX_PATH}/client/clientList`,
    component: React.lazy(() =>import("views/app-views/clientDetails/clientList")),
  },
];
